import $ from 'jquery';
import { toggleButtonLoader } from '../utils/button-loader';
import SetDropdownValue from './set-dropdown-value';
export default class AjaxForm {
    static init() {
        $(document).on('submit', '.js__ajax-form', event => {
            event.preventDefault();
            const $form = $(event.currentTarget);
            const $submit = $form.find(':submit');
            if ($submit.is('.disabled')) {
                return;
            }
            $.ajax({
                method: $form.attr('method'),
                url: $form.attr('action'),
                data: $form.serialize(),
                beforeSend() {
                    toggleButtonLoader($submit, true);
                    $form.find('.js__remove-on-form-request').remove();
                },
            })
                .done(data => {
                $form.html(data);
                const successReload = $form.data('success-reload');
                const $modal = $form.is('.ui.modal') ? $form : $form.closest('.ui.modal');
                if ($modal.length) {
                    $modal.modal('hide');
                }
                if ($form.data('success-template')) {
                    const $formParent = $form.parent();
                    $formParent.html(data);
                    $formParent.find('.ui.dropdown, select').dropdown();
                    // @ts-ignore
                    $formParent.find('.ui.checkbox').checkbox();
                    SetDropdownValue.init($formParent);
                }
                else if (successReload) {
                    window.location.reload();
                }
            })
                .fail(xhr => {
                $form.html(xhr.responseText);
            })
                .always(() => {
                $form.find('.ui.dropdown, select').dropdown();
                toggleButtonLoader($submit, false);
            });
        });
    }
}
